module.exports = __webpack_public_path__ + "img/icon28.fe797247.fe797247.svg";